import { z } from "zod";

export const bindDriverToTripPayloadSchema = z.object({
  tripUuid: z.uuid(),
});

export type BindDriverToTripPayload = z.infer<
  typeof bindDriverToTripPayloadSchema
>;
